import { TextSearchInputValueCollectingVisitor } from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/text-search-input-value-collecting-visitor.tsx';
import type { TextSearchInputClauseType } from '@atlassian/jira-jql-utils/src/utils/text-search-input-clause/types.tsx';
import { TEXT_FIELDS } from '../../../common/constants.tsx';

/**
 * Check if search input clause is valid
 */
export const validate = (compoundClause: TextSearchInputClauseType): boolean => {
	if (!compoundClause) {
		return true;
	}
	try {
		compoundClause.accept(new TextSearchInputValueCollectingVisitor(TEXT_FIELDS));
		return true;
	} catch (e) {
		return false;
	}
};
